module.exports = __webpack_public_path__ + "static/media/gdc-interiors.60a20fa2.png";